export default "__VITE_ASSET__BopTf6rd__"